import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './DocumentsHeadRow.scss';

export const DOCUMENTS_TABLE_HEADER = [
  {
    label: 'authorAndDate'
  },
  {
    label: 'note'
  },
  {
    label: 'document'
  },
  {
    label: 'notificationDate'
  },
  {
    label: 'expirationDate'
  },
  {
    label: 'actions',
    width: '10%'
  }
];

export const DocumentsHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {DOCUMENTS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'documents-table-head'} width={head.width}>
          <div className={'documents-table-head-block'}>
            <span>{i18n.getMessage(`documents.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};
